import Map from './Map'
import UnitStrip from './UnitStrip'
import UnitDetailSheet from './UnitDetailSheet'

// Mobile dashboard: full-bleed map + swipeable unit strip + bottom-sheet detail.
// State is owned by index.jsx; selecting a unit opens the sheet, clearing it closes it.
export const DashboardMobile = ({ vehicles, selectedUnitID, mapCoord, dispatch,
  handleMarkerClick, onSelectUnit, onCloseDetail }) => {
  const selected = selectedUnitID ? (vehicles || []).filter(i => i.unit_id.startsWith(selectedUnitID))[0] : null
  return (
    <div className="rz-dashboard-mobile">
      <Map handleClick={handleMarkerClick} selectedUnitID={selectedUnitID} mapCoord={mapCoord} vehicles={vehicles} />
      <UnitStrip vehicles={vehicles} selectedUnitID={selectedUnitID} onSelect={onSelectUnit} />
      <UnitDetailSheet item={selected} dispatch={dispatch} open={!!selected} onClose={onCloseDetail} />
    </div>
  )
}
export default DashboardMobile
